<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <div class="mt-4 text-center">
      <BaseCard heading="Nuevo Plato">
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-row>
              <v-col lg="6" md="6" sm="6" class="col-12">
                <v-text-field
                  :counter="10"
                  :rules="[
                    (v) => !!v || 'ID Plato es requerido',
                    (v) => (v && v.length <= 10) || 'ID de solo 10 caracteres'
                  ]"
                  required
                  v-model="idplato"
                  label="ID"
                  solo
                ></v-text-field>
                <v-text-field
                  :rules="[(v) => !!v || 'Descripcion es requerida']"
                  required
                  v-model="descripcion"
                  label="Descripción"
                  solo
                ></v-text-field>
                <v-text-field v-model="descripcionCorta" label="Descripción Corta" solo></v-text-field>
              </v-col>
              <v-col sm="6" md="6" lg="6" class="col-12">
                <v-checkbox
                  class="mx-2"
                  v-model="desayuno"
                  label="Desayuno"
                  color="success"
                  value="desayuno"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  class="mx-2"
                  v-model="almuerzo"
                  label="Almuerzo"
                  color="success"
                  value="almuerzo"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  class="mx-2"
                  v-model="cena"
                  label="Cena"
                  color="success"
                  value="cena"
                  hide-details
                ></v-checkbox>
                <v-checkbox
                  class="mx-2"
                  v-model="aceptaTaper"
                  label="Acepta Taper"
                  color="success"
                  value="aceptaTaper"
                  hide-details
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" @click="cancelar()">Cerrar</v-btn>
          <v-btn color="info" submit @click="guardar()">Guardar</v-btn>
        </v-card-actions>
      </BaseCard>
      <div v-if="showLoading" class="progress-background">
        <v-progress-circular :size="70" :width="7" color="primary" indeterminate></v-progress-circular>
      </div>
      <v-snackbar v-model="snackbar" timeout="3000">
        {{ text }}
        <v-btn color="info" text @click="snackbar = false">
          Cerrar
        </v-btn>
      </v-snackbar>
    </div>
  </v-container>
</template>

<script>
import GestionPlatoService from '../services/GestionPlatoService';
export default {
  name: 'GestionPlatoFormulario',
  data: () => ({
    valid: true,
    snackbar: false,
    text: '',
    showLoading: false,
    gestionPlatoService: null,
    desayuno: false,
    almuerzo: false,
    cena: false,
    aceptaTaper: false,
    descripcion: '',
    descripcionCorta: '',
    idplato: '',
    page: {
      title: 'Comedor'
    },
    breadcrumbs: [
      {
        text: 'Gestión de Platos',
        disabled: true
      },
      {
        text: 'Lista de Platos',
        disabled: true
      },
      {
        text: 'Agregar',
        disabled: true
      }
    ]
  }),
  watch: {},
  methods: {
    open() {
      this.showLoading = true;
    },
    close() {
      this.showLoading = false;
    },
    cancelar() {
      this.$router.push({ path: '/comedor/gestion_plato' });
    },
    async guardar() {
      this.open();
      if (this.$refs.form.validate()) {
        const res = await this.gestionPlatoService.post().execResource('plato', {
          exportacion: [
            {
              idempresa: localStorage.getItem('emp'),
              idplato: this.idplato,
              descripcion: this.descripcion,
              descripcioncorta: this.descripcionCorta,
              desayuno: this.desayuno ? 1 : 0,
              almuerzo: this.almuerzo ? 1 : 0,
              cena: this.cena ? 1 : 0,
              aceptataper: this.aceptaTaper ? 1 : 0
            }
          ]
        });
        if (res.status) {
          this.text = res.message;
          this.snackbar = true;
          this.idplato = '';
          this.descripcion = '';
          this.descripcionCorta = '';
          this.desayuno = false;
          this.almuerzo = false;
          this.cena = false;
          this.aceptaTaper = false;
        } else {
          this.text = res.message[0].error;
          this.snackbar = true;
        }
        this.$refs.form.reset();
      }
      this.close();
    }
  },
  async mounted() {
    this.gestionPlatoService = this.$httpService(new GestionPlatoService(), this);
  }
};
</script>
